import angular from 'angular';

import rosterEmptyStatesComponent from '@web/roster/EmptyStates/RosterEmptyStatesAngular';

import r2a from '../../react/angularIntegration/r2a';

import rosterComponent from './components/rosterComponent';
import rosterEmpty from './components/rosterEmptyComponent';
import rosterHeaderComponent from './components/rosterHeaderComponent';
import rosterFiltersComponent from './components/rosterFiltersComponent';
import rosterTableComponent from './components/rosterTableComponent';
import rosterActionsComponent from './components/rosterActionsComponent';
import rosterTableColumn from './directives/rosterTableColumn';
import RosterService from './services/RosterService';
import RosterUtilsService from './services/RosterUtilsService';
import RosterPrintPayloadReplacer from './services/RosterPrintPayloadReplacer';

const rosterModule = angular
  .module('sling.roster', [])
  .component('roster', rosterComponent)
  .component('rosterEmpty', rosterEmpty)
  .component('rosterHeader', rosterHeaderComponent)
  .component('rosterFilters', rosterFiltersComponent)
  .component('rosterTable', rosterTableComponent)
  .component('rosterActions', rosterActionsComponent)
  .component('rRosterEmptyStates', r2a(rosterEmptyStatesComponent))
  .directive('rosterTableColumn', rosterTableColumn)
  .service('RosterService', RosterService)
  .service('RosterUtils', RosterUtilsService)
  .factory('rosterPrintPayloadReplacer', RosterPrintPayloadReplacer);

export default rosterModule.name;
